module.exports = __webpack_public_path__ + "img/phone_bill_content_bg.88443c2c.png";